var map = {
	"./avatar/1.png": 25,
	"./avatar/2.png": 9686,
	"./avatar/3.png": 7684,
	"./avatar/4.png": 2204,
	"./avatar/5.png": 6896,
	"./back-btn.png": 3719,
	"./badge/1.png": 9832,
	"./badge/2.png": 1134,
	"./badge/3.png": 7833,
	"./badge/4.png": 9560,
	"./badge/5.png": 3817,
	"./btn-form.png": 2689,
	"./btn-login-text.png": 9460,
	"./circle/1.png": 1037,
	"./circle/2.png": 4539,
	"./circle/3.png": 811,
	"./circle/4.png": 2617,
	"./circle/5.png": 1749,
	"./close-handbook.png": 1894,
	"./color-1.png": 1513,
	"./color-2.png": 2115,
	"./color-3.png": 1468,
	"./color-4.png": 1548,
	"./color-5.png": 213,
	"./complete-btn.png": 8678,
	"./create-bg.jpg": 565,
	"./create-box.png": 8250,
	"./dropdown-icon.png": 2507,
	"./explore-btn.png": 4717,
	"./finish-btn-text.png": 4143,
	"./finish-btn.png": 9816,
	"./game-1-btn.png": 3622,
	"./game-1.jpg": 6111,
	"./game-2-btn.png": 7429,
	"./game-2.jpg": 4049,
	"./game-3-btn-2.png": 4116,
	"./game-3-btn.png": 7271,
	"./game-3.jpg": 6305,
	"./game-frame.png": 4659,
	"./handbook.png": 4054,
	"./home-bg-mobile.jpg": 3472,
	"./home-bg.jpg": 9559,
	"./home-bg.png": 7256,
	"./home-btn-create.png": 8519,
	"./home-btn-handbook.png": 1158,
	"./home-btn-labo.png": 6782,
	"./home-btn-lockers.png": 9507,
	"./home-btn-theatre.png": 5695,
	"./home-dolls.png": 6926,
	"./home-guide-character.png": 4696,
	"./home-guide-name.png": 3750,
	"./labo-guide-character.png": 126,
	"./labo-guide-frame.png": 1646,
	"./labo-guide-name.png": 2463,
	"./labo_ic_1.png": 1600,
	"./labo_ic_2.png": 2813,
	"./labo_ic_3.png": 451,
	"./labor-bg.jpg": 9581,
	"./line-bot.png": 8165,
	"./line-head.png": 3901,
	"./locker-bg.jpg": 3950,
	"./locker-circle-clawdeen.png": 2775,
	"./locker-circle-cleo.png": 6282,
	"./locker-circle-draculaura.png": 3682,
	"./locker-circle-frankie.png": 269,
	"./locker-circle-lagoona.png": 2352,
	"./locker-clawdeen.png": 1862,
	"./locker-cleo.png": 264,
	"./locker-detail-box.png": 1345,
	"./locker-detail-close.png": 8372,
	"./locker-detail/clawdeen.png": 7457,
	"./locker-detail/cleo.png": 3498,
	"./locker-detail/draculaura.png": 9156,
	"./locker-detail/frankie.png": 7200,
	"./locker-detail/lagoona.png": 1909,
	"./locker-doll-shadow.png": 1433,
	"./locker-draculaura.png": 9263,
	"./locker-frankie.png": 6134,
	"./locker-icon-left.png": 8963,
	"./locker-icon-right.png": 2579,
	"./locker-lagoona.png": 1313,
	"./locker-name/clawdeen.png": 6500,
	"./locker-name/cleo.png": 7304,
	"./locker-name/draculaura.png": 8228,
	"./locker-name/frankie.png": 7090,
	"./locker-name/lagoona.png": 2862,
	"./locker-shadow.png": 9514,
	"./login-btn-2.png": 2993,
	"./login-btn.png": 7339,
	"./login-create-btn.png": 8862,
	"./m-book-1.png": 2258,
	"./m-book-2.png": 7633,
	"./m-book-next.png": 3298,
	"./m-book-prev.png": 2618,
	"./m-create-box.png": 7102,
	"./m-game-1-btn.png": 4650,
	"./m-game-2-btn.png": 8497,
	"./m-game-3-btn-2.png": 3241,
	"./m-game-3-btn.png": 7675,
	"./m-guide-frame.png": 7432,
	"./m-locker-bg.jpg": 7649,
	"./m-locker-title-ic-1.png": 8133,
	"./m-locker-title-ic-2.png": 3215,
	"./m-profile-flag-bg.png": 8451,
	"./m-theatre-bg.jpg": 840,
	"./main-logo.png": 8017,
	"./next-btn.png": 2909,
	"./point-box.png": 4409,
	"./profile-box-bg.png": 615,
	"./profile-edit-btn.png": 5667,
	"./profile-flag-bg.png": 7295,
	"./rect/1.png": 2904,
	"./rect/2.png": 5277,
	"./rect/3.png": 3557,
	"./rect/4.png": 7600,
	"./rect/5.png": 8560,
	"./round/1.png": 5064,
	"./round/2.png": 2056,
	"./round/3.png": 3614,
	"./round/4.png": 5353,
	"./round/5.png": 8063,
	"./shape-one.png": 9377,
	"./shape-three.png": 8932,
	"./shape-two.png": 854,
	"./slide-next.png": 1402,
	"./slide-prev.png": 1578,
	"./stay-btn.png": 1892,
	"./step-1-btn-text.png": 2164,
	"./step-2-btn-text.png": 9633,
	"./step-2-btn.png": 883,
	"./step-forward.png": 1047,
	"./step-one.png": 2042,
	"./step-two.png": 4517,
	"./theatre-bg.jpg": 1753,
	"./theatre-guide-character.png": 1162,
	"./theatre-guide-name.png": 3373,
	"./thumbnail-1-All.jpg": 8424,
	"./thumbnail-2-Draculaura.jpg": 5954,
	"./thumbnail-3-Clawdeen.jpg": 1746,
	"./thumbnail-4-Frankie.jpg": 7172,
	"./thumbnail-5-Lagoona.jpg": 192,
	"./thumbnail-6-Cleo.jpg": 6179,
	"./todo/create.png": 3177,
	"./todo/labo_match.png": 2688,
	"./todo/labo_quiz.png": 2245,
	"./todo/labo_trivia.png": 4471,
	"./todo/lockers.png": 8924,
	"./todo/theatre.png": 39,
	"./video-frame.png": 2093,
	"./view-profile-btn.png": 223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;